export default __webpack_public_path__ + "static/media/Karnataka-Southern.70259c11.png";